import Price from "../common/Price";
import {BomMaterialApiDto, BomPreviewDetailsAssetApiDto, BomPreviewDetailsItemsApiDto} from "../../api/model/rest";
import {none, option, Option} from "ts-option";

/**
 * Items of detailed bill of materials for selected merchant
 */
export class BillOfMaterialsPreviewItems {
	constructor(
		public readonly assets: BillOfMaterialsPreviewAsset[]
	) {}

	static fromJson(json: BomPreviewDetailsItemsApiDto): BillOfMaterialsPreviewItems {
		return new BillOfMaterialsPreviewItems(json.assets.map(BillOfMaterialsPreviewAsset.fromJson)
			.sort((a, b) => Number(a.selfSourced) - Number(b.selfSourced)))
	}

	static copyToClipboard(assets: BillOfMaterialsPreviewAsset[]) {

		const createCell = (text: string) => {
			cell = row.insertCell(-1);
			cell.style.border = "1px solid black";
			cell.style.padding = "5px";
			cell.innerHTML = text;
		}

		const table = document.createElement("table");
		table.id = 'billOfMaterialsToClipboard';
		table.style.position = 'fixed';
		table.style.top = "0";
		table.style.left = "0";
		table.style.borderCollapse = "collapse";
		table.style.border = "1px solid black";
		let row: HTMLTableRowElement, cell: HTMLTableDataCellElement;
		const theadTitles = ['Description', 'Quantity', 'Merchant Code', 'Manufacturer Code', 'Price'];
		const thead = table.createTHead();
		row = thead.insertRow(0);
		theadTitles.map(createCell);
		const tbody = table.createTBody();
		assets.filter(a => !a.selfSourced).map(asset => {
			if (asset.materials.length) {
				asset.materials.map(material => {
					row = tbody.insertRow(-1);
					createCell(material.description.toUpperCase());
					createCell((material.quantity * asset.quantity).toString());
					createCell(material.codeAtMerchant.getOrElse(''));
					createCell(material.codeAtManufacturer.getOrElse(''));
					createCell(material.buy.map(buy => buy.format()).getOrElse(''));
				});
			}
			else {
				row = tbody.insertRow(-1);
				createCell(asset.name + asset.manufacturerName.map(mn => ` (${mn})`).getOrElse(""));
				createCell(asset.quantity.toString());
				createCell("(unknown)");
				createCell("(unknown)");
				createCell("(unknown)");
			}
		});

		document.body.appendChild(table);

		const elementToCopy = document.getElementById('billOfMaterialsToClipboard');
		if (document.createRange && window.getSelection) {
			const range = document.createRange();
			const sel = window.getSelection();
			sel.removeAllRanges();
			try {
				range.selectNodeContents(elementToCopy);
				sel.addRange(range);
			}
			catch (e) {
				range.selectNode(elementToCopy);
				sel.addRange(range);
			}
		}

		try {
			document.execCommand('copy');
		}
		catch (err) {
			console.error(err);
		}

		document.body.removeChild(table);
	}

}

export class BillOfMaterialsPreviewAsset {
	constructor(
		public readonly buy: Option<Price>,
		public readonly manufacturerName: Option<string>,
		public readonly margin: Price,
		public readonly materials: BillOfMaterialsPreviewItemOfMaterial[],
		public readonly name: string,
		public readonly profit: Option<Price>,
		public readonly profitInPercentage: Option<number>,
		public readonly quantity: number,
		public readonly rebate: Price,
		public readonly sell: Price,
		public readonly rebateUnitPrice: Price,
		public readonly sellUnitPrice: Price,
		public readonly selfSourced: boolean
	) {}

	static fromJson(json: BomPreviewDetailsAssetApiDto): BillOfMaterialsPreviewAsset {
		const manufacturerName = json.manufacturerName ? option(json.manufacturerName) : none;
		const buy = json.buy ? option(Price.fromJson(json.buy)) : none;
		const profit = json.profit ? option(Price.fromJson(json.profit)) : none;
		const profitInPercentage = json.profitInPercentage ? option(json.profitInPercentage) : none;
		return new BillOfMaterialsPreviewAsset(buy, manufacturerName, Price.fromJson(json.margin),
			json.materials.map(BillOfMaterialsPreviewItemOfMaterial.fromJson),
			json.name, profit, profitInPercentage, json.quantity, Price.fromJson(json.rebate), Price.fromJson(json.sell),
			Price.fromJson(json.rebateUnitPrice), Price.fromJson(json.sellUnitPrice), json.selfSourced);
	}
}

export class BillOfMaterialsPreviewItemOfMaterial {
	constructor(
		public readonly id: Option<string>,
		public readonly materialId: Option<string>,
		public readonly description: string,
		public readonly buy: Option<Price>,
		public readonly buyUnitPrice: Option<Price>,
		public readonly codeAtManufacturer: Option<string>,
		public readonly codeAtMerchant: Option<string>,
		public readonly quantity: number) {}

	static fromJson(json: BomMaterialApiDto): BillOfMaterialsPreviewItemOfMaterial {
		const codeAtManufacturer = json.codeAtManufacturer ? option(json.codeAtManufacturer) : none;
		const codeAtMerchant = json.codeAtMerchant ? option(json.codeAtMerchant) : none;
		const buy = json.buy ? option(Price.fromJson(json.buy)) : none;
		const unitPrice = json.buyUnitPrice ? option(Price.fromJson(json.buyUnitPrice)) : none;
		return new BillOfMaterialsPreviewItemOfMaterial(option(json.id), option(json.materialId), json.description, buy,
			unitPrice, codeAtManufacturer, codeAtMerchant, json.quantity);
	}
}
